module.exports = __webpack_public_path__ + "static/media/image (42).f4a5ee83.jpg";